// extracted by mini-css-extract-plugin
module.exports = {"component":"end-turn-button_component___vt_0"};